import { AiOutlineCheckCircle } from "react-icons/ai";

import "./experience.css";
import { SectionProps, Sections } from "../../App";
import { JOBS, Job } from "./config";

const Experience = ({ observeElement }: SectionProps) => {
  const JobCard = ({ job }: { job: Job }) => {
    const { image, role, company, date, descriptions } = job;
    return (
      <article
        className="experience__job"
        key={company + descriptions?.[0]}
        ref={observeElement}
      >
        <div className="experience__logo">
          <img
            src={image}
            alt={`${company} logo`}
          />
        </div>

        <div className="experience__content">
          <h3 className="experience__title">{role}</h3>

          <div className="experience__subtitle">
            <h4 className="experience__company">{company}</h4>
            <h4 className="experience__date">{date}</h4>
          </div>

          <div className="experience__descriptions">
            {descriptions?.map((description) => (
              <div
                className="experience__description"
                key={description.text}
              >
                <div className="experience__bullet">
                  <AiOutlineCheckCircle />
                </div>
                <small>{description.text}</small>
              </div>
            ))}
          </div>
        </div>
      </article>
    );
  };

  return (
    <section id={Sections.EXPERIENCE}>
      <h2>Work experience</h2>
      <div className="container experience__container">
        <div className="experience__jobs">
          {JOBS.map((job) => (
            <JobCard
              key={job.company + job.descriptions?.[0]}
              job={job}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
